import React, { useState, useRef, useEffect } from "react";
import "../../css/designSystem/Navbar.css";
import logo from "../../assets/icons/navbar_logo.svg";
import { useNavigate, useLocation } from "react-router-dom";
import SecondaryButton from "./buttons/SecondaryButton";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showCalculatorsDropdown, setShowCalculatorsDropdown] = useState(false);

  const servicesRef = useRef(null);
  const calculatorsRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (servicesRef.current && !servicesRef.current.contains(event.target)) {
        setShowServicesDropdown(false);
      }

      if (
        calculatorsRef.current &&
        !calculatorsRef.current.contains(event.target)
      ) {
        setShowCalculatorsDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== "/") {
      navigate(`/#${sectionId}`);
      return;
    }

    const section = document.getElementById(sectionId);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      window.history.pushState(null, "", `/#${sectionId}`);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img
          src={logo}
          alt="Merrick Platts Logo"
          className="navbar-logo"
          onClick={() => navigate("/")}
        />
      </div>

      <ul className="navbar-links">
        <li>
          <span
            className="nav-text"
            onClick={() => scrollToSection("about-us")}
          >
            About Us
          </span>
        </li>

        <li>
          <span
            className="nav-text"
            onClick={() => scrollToSection("how-we-can-help")}
          >
            How we can help
          </span>
        </li>

        <li>
          <span
            className="nav-text"
            onClick={() => scrollToSection("why-choose-us")}
          >
            Why Choose Us
          </span>
        </li>
      </ul>

      <div className="row gap-m row-center">
        <SecondaryButton
          onClick={() => scrollToSection("contact-us")}
          text="Contact Us"
        />
      </div>
    </nav>
  );
};

export default Navbar;
